module.exports = __webpack_public_path__ + "static/img/11.39f9843.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/11.png
// module id = 1XDI
// module chunks = 0